<div class="coupons-preview"
     [class.device-desktop]="deviceType === 'desktop'"
     [class.device-tablet]="deviceType === 'tablet'"
     [class.device-mobile]="deviceType === 'mobile'">
  <!-- Header Section -->
  <div class="website-element header-element" 
       *ngIf="isSectionVisible('header')"
       [class.selected]="getHeaderElement()?.selected"
       (click)="onHeaderClick()">
    <app-dark-page-header
      [logo]="getHeaderLogo()"
      [navigation]="getHeaderNavigation()"
      [ctaButton]="getHeaderCTAButton()"
      [visible]="true"
      [clickable]="true"
      [deviceType]="deviceType"
      [selected]="getHeaderElement()?.selected || false"
      [headingColor]="headingColor"
      [headingFont]="headingFont"
      [backgroundColor]="getHeaderBackgroundColor()"
      (navigationClick)="onNavigationClick($event)">
    </app-dark-page-header>
  </div>

  <!-- Page Header Section -->
  <section 
    class="page-header-section website-element coupons-page-header-element" 
    *ngIf="isSectionVisible('page-title')"
    [class.selected]="getCouponSectionElement()?.selected"
    (click)="onPageHeaderSectionClick($event)">
    <div class="page-header-container">
      <h1 class="section-title"
          [style.color]="getHeadingColor()"
          [style.font-family]="getHeadingFont()"
          [ngStyle]="getTitleStyles()">{{ getPageTitle() }}</h1>
      <p class="section-subtitle"
         [style.color]="getParagraphColor()"
         [style.font-family]="getBodyFont()">{{ getPageSubtitle() }}</p>
    </div>
  </section>

  <!-- Coupon Card Section -->
  <section 
    class="coupon-section website-element coupons-coupon-element" 
    *ngIf="isSectionVisible('coupon_card')"
    [class.selected]="getCouponSectionElement()?.selected"
    (click)="onCouponCardClick($event)">
    <div class="coupon-container">
      <div class="coupon-card">
        <div class="coupon-left" [style.background-color]="getCouponTagColor()">
          <div class="coupon-label">COUPON</div>
        </div>
        <div class="coupon-right">
          <div class="coupon-header">{{ getPromoCodeLabel() }}</div>
          <div class="coupon-code" [style.color]="getCouponTagColor()">{{ getPromoCode() }}</div>
          <div class="coupon-footer">
            <div class="available-text">{{ getPromoCodeNote() }}</div>
            <div class="wash-types">
              <span class="wash-badge" *ngFor="let washType of getWashTypes(); trackBy: trackByIndex">{{ washType }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Instructions Section -->
  <section 
    class="instructions-section website-element coupons-instructions-element" 
    *ngIf="isSectionVisible('instructions_section')"
    [class.selected]="getCouponSectionElement()?.selected"
    (click)="onInstructionsSectionClick($event)">
    <div class="instructions-container">
      <div class="instructions-card">
        <h2 class="instructions-title"
            *ngIf="getInstructionHeading()"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()">{{ getInstructionHeading() }}</h2>
        
        <p class="instructions-paragraph"
           *ngIf="getInstructionParagraph()"
           [style.color]="getParagraphColor()"
           [style.font-family]="getBodyFont()">{{ getInstructionParagraph() }}</p>
        
        <div class="steps-list">
          <div class="step-item" *ngFor="let step of getInstructionSteps(); trackBy: trackByIndex">
            <div class="step-number">{{ step.number }}.</div>
            <div class="step-content">
              <h3 class="step-title"
                  [style.color]="getHeadingColor()"
                  [style.font-family]="getHeadingFont()">{{ step.title }}</h3>
              <p class="step-description"
                 [style.color]="getParagraphColor()"
                 [style.font-family]="getBodyFont()">
                {{ step.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <div class="website-element footer-element" 
       *ngIf="isSectionVisible('footer')"
       [class.selected]="getFooterElement()?.selected"
       (click)="onElementClick(getFooterElement()!)">
    <app-dark-page-footer 
      [quickLinks]="getFooterQuickLinks()"
      (quickLinkClick)="onNavigationClick($event)"
      [quickLinksTitle]="getFooterQuickLinksTitle()"
      [socialLinks]="getFooterSocialLinks()"
      [socialLinksTitle]="getFooterSocialLinksTitle()"
      [copyright]="getFooterCopyright()"
      [logo]="getFooterLogo()"
      [deviceType]="deviceType"
      [backgroundColor]="getFooterBackgroundColor()">
    </app-dark-page-footer>
  </div>
</div>

